var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"block",on:{"click":function($event){$event.stopPropagation();return _vm.params.colDef.CellRendererParams.paySlipSidebarFunction(_vm.params.data.id)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("visibility")])])
}
var staticRenderFns = []

export { render, staticRenderFns }